module.exports = __webpack_public_path__ + "static/img/attestation-logo.2587808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/attestation-logo.png
// module id = yUKg
// module chunks = 1